import { type ReactNode, useContext } from "react";

import { Box } from "@/components";
import { useTheme } from "@/hooks";
import { ClientOnlyPortal } from "@/overlays/ClientOnlyPortal";
import { TooltipOverlay } from "@/overlays/TooltipOverlay";
import { BiomePortalIdContext } from "@/providers/BiomePortalIdProvider/BiomePortalIdProvider";
import { mergeSx } from "@/utils/styleHelpers";

import { positionedOverlayContainerCss } from "../shared";
import { BiomeTooltipProvider } from "./tooltipContext";

const SELECTOR = "tooltip-container";
export function MountedTooltipOverlayAndProvider({
  children,
}: {
  children: ReactNode;
}) {
  const portalId = useContext(BiomePortalIdContext);
  const {
    base: { zLevel },
  } = useTheme();
  return (
    <BiomeTooltipProvider>
      {children}

      {/* TOOLTIP */}
      <ClientOnlyPortal selector={`#${SELECTOR}${portalId}`}>
        <TooltipOverlay />
      </ClientOnlyPortal>
      <Box
        id={`${SELECTOR}${portalId}`}
        sx={mergeSx(positionedOverlayContainerCss, {
          zIndex: zLevel.tooltip,
        })}
      />
    </BiomeTooltipProvider>
  );
}
